import { createModel } from "hox";
import { useEffect, useState } from "react";
import { rateSetService } from "./rateSetService";
import { TablePaginationConfig } from "antd/es/table/interface";
import { EditModeType, ISearchPage } from "@src/types/FmsTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@utils/constants";
import { IMdUserDetail, IMdUserFields } from "./rateSetTypes";
import { appService } from "../../app/AppService";
import { ISelectOption } from "@src/components/YhFormBox/Types";


export function transPgToPagination(pg: {total: number, pageSize: number, pageNum: number}) {
    return {
        total: pg.total,
        pageSize: pg.pageSize,
        current: pg.pageNum
    }
}


function useModel() {
    const initSearchParam: IMdUserFields = {};
    const initDataSource: IMdUserDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IMdUserFields>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IMdUserDetail[]>(initDataSource);
    //表格选中行
    const [selectedRow, setSelectedRow] = useState<IMdUserDetail>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [drawerVisible, setDrawerVisible] = useState(false);
    // 详情类型
    const [editType, setEditType] = useState<EditModeType>()
    const [resetState, setResetState] = useState(false)


    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
        setResetState(!resetState)
    }

    /**
     * 加载选择项
     */
    const loadDs = async () => {
        
    }

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IMdUserFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
    }
    const loadData = async (page?: ISearchPage, searchValue: IMdUserFields = searchParam) => {
        const {startTime, endTime, ...search} = searchValue
        const searchParams = {
            // ...searchValue,
            startTime: startTime ?? null,
            endTime: endTime ?? null,
            searchItem:{...search },
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            orders: [{'column':'createTime','rule':'DESC'}]
        }
        let { retData } = await rateSetService.page(searchParams);
        // let { retData } = await rateSetService.page(searchParams);
        const { list, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(list);
    }

    const [appDs, setAppDs] = useState<ISelectOption[]>([])
    const loadAppPage = async () => {
        const searchParams = {
            page: {
                pageSize: 10000,
                pageNum: 1,
            }
        }
        let { retData } = await appService.page(searchParams);
        const { records } = retData;
        setAppDs(records.map(i => ({label: i.name || '', value: i.code || ''})));
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRow,
        pgCfg,
        drawerVisible,
        resetState,
        editType,
        appDs,
        /***method***/
        setDataSource,
        setSelectedRow,
        resetSearchParam,
        updateSearchParam,
        setEditType,
        loadData,
        updatePgCfg,
        setDrawerVisible,
        onSearch,
        onReset,
        loadDs,
        loadAppPage
    }

}


export const rateSetModel = createModel(useModel);